import { Button } from '@alexpireddu/map-ui';
import styled from '@emotion/styled';
import { FC, useCallback } from 'react';
import { VideoTableCampaign } from '../../apis/videoApis';
import { useModalProvider } from '../../components';
import { colors } from '../../theming/theme';
import ConfirmPaymentModal, {
  ConfirmPaymentModalProps,
} from './ConfirmPaymentModal';

export interface ConfirmPaymentButtonProps {
  campaign: VideoTableCampaign;
  onReloadCampaigns: Function;
}

const ButtonStyled = styled(Button)({
  backgroundColor: colors.warning300,
  color: colors.text400,
  border: 'none',
  paddingLeft: '32px',
  paddingRight: '32px',
});

const ConfirmPaymentButton: FC<ConfirmPaymentButtonProps> = ({
  campaign,
  onReloadCampaigns,
}) => {
  const { openModal, closeModal } = useModalProvider();

  const handleCloseModal = useCallback(
    (reload: boolean) => {
      closeModal({
        identifier: 'ConfirmPaymentModal',
      });

      if (reload) {
        onReloadCampaigns();
      }
    },
    [closeModal, onReloadCampaigns]
  );

  const handleClick = useCallback(() => {
    openModal<ConfirmPaymentModalProps>({
      identifier: 'ConfirmPaymentModal',
      component: ConfirmPaymentModal,
      additionalProps: {
        campaign,
        onClose: handleCloseModal,
      },
    });
  }, [openModal, handleCloseModal, campaign]);

  return (
    <ButtonStyled variant="primary" size="sm" onClick={handleClick}>
      Conferma pagamento
    </ButtonStyled>
  );
};

export default ConfirmPaymentButton;
